import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface IViewProfileStrings extends LocalizedStringsMethods {
    lsOrgTxt: string;
    lsLevelTxt: string;
    lsProfilesTxt: string;
    lsIDTxt: string;
    lsSportTxt: string;
    lsBDayTxt: string;
    lsGenderTxt: string;
    lsBaselineTxt: string;
    lsTotalTestTxt: string;
    lsContactInfoTxt: string;
    lsEmailTxt: string;
    lsPhoneTxt: string;
    lsNotifyEmailTxt: string;
    lsNotifyPhonesTxt: string;
    lsTestHistoryTxt: string;
    lsShareTextTxt: string;
    lsPrintTxt: string;
    lsDownloadTxt: string;
    lsExportTxt: string;
    lsOkTxt: string;
    lsTestExportSuccessTxt: string;
    lsTestSharedSuccessTxt: string;
    lsTestShareFailTxt: string;
    lsShareTxt: string;
    lsExportProfileTxt: string;
}

let strings: IViewProfileStrings;
export default strings = new LocalizedStrings({
    en: {        
        lsOrgTxt: 'Organization',
        lsLevelTxt: 'Level',
        lsProfilesTxt: 'Profiles',
        lsEditTxt: 'Edit',
        lsIDTxt: 'Id',
        lsSportTxt: 'Sport(s)',
        lsBDayTxt: 'Birthdate',
        lsGenderTxt: 'Gender',
        lsBaselineTxt: 'Baseline',
        lsTotalTestTxt: 'Total Tests',
        lsContactInfoTxt: 'Contact & Notify Info',
        lsEmailTxt: 'Email',
        lsPhoneTxt: 'Phone',
        lsNotifyEmailTxt: 'Notify Email(s)',
        lsNotifyPhonesTxt: 'Notify Phone(s)',
        lsTestHistoryTxt: 'Test History',
        lsShareTextTxt: 'Share Test',
        lsPrintTxt : 'Print',
        lsDownloadTxt: 'Download',
        lsExportTxt: 'Export Profile List',
        lsOkTxt: 'Ok',
        lsTestExportSuccessTxt: 'Tests exported successfully!',        
        lsTestSharedSuccessTxt: 'Tests shared successfully!',
        lsTestShareFailTxt: 'Tests could not be shared.Please try again!',
        lsShareTxt: 'Share',
        lsExportProfileTxt: 'Export Profile List'
    },
    es: {       
        lsOrgTxt: 'Organización',
        lsLevelTxt: 'Nivel',
        lsProfilesTxt: 'Profile',
        lsEditTxt: 'Editar',
        lsIDTxt: 'Carné de identidad',
        lsSportTxt: 'Deportes',
        lsBDayTxt: 'Fecha de nacimiento',
        lsGenderTxt: 'Género',
        lsBaselineTxt: 'Base',
        lsTotalTestTxt: 'Pruebas totales',
        lsContactInfoTxt: 'Contacto y notificación de información',
        lsEmailTxt: 'Email',
        lsPhoneTxt: 'Teléfono',
        lsNotifyEmailTxt: 'Notificar correo electrónico (s)',
        lsNotifyPhonesTxt: 'Notificar teléfono (s)',
        lsTestHistoryTxt: 'Historial de prueba',
        lsShareTextTxt: 'Compartir prueba',
        lsPrintTxt : 'Impresión',
        lsDownloadTxt: 'Descargar',
        lsExportTxt: 'Exportar lista de perfiles',
        lsOkTxt: 'De acuerdo',
        lsTestExportSuccessTxt: 'Pruebas exportadas con éxito',        
        lsTestSharedSuccessTxt: '¡Pruebas compartidas exitosamente!',
        lsTestShareFailTxt: 'Las pruebas no se pudieron compartir. ¡Inténtalo de nuevo!',
        lsShareTxt: 'Share',
        lsExportProfileTxt: 'Export Profile List'
     }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/profile/strings.profile.view.tsx